import { render, staticRenderFns } from "./WFormSelect.vue?vue&type=template&id=4b578643&"
import script from "./WFormSelect.vue?vue&type=script&lang=ts&"
export * from "./WFormSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports